import { render } from "./projects-form-page.vue?vue&type=template&id=518805fa"
import script from "./projects-form-page.vue?vue&type=script&lang=js"
export * from "./projects-form-page.vue?vue&type=script&lang=js"

import "./projects-form-page.vue?vue&type=style&index=0&id=518805fa&lang=scss"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__